exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tree-payments-options .list-group .list-group-item, #tree-payments-options-collapsed .list-group .list-group-item {\n  background-color: rgba(218, 213, 213, 0.85);\n  color: #7E7979; }\n  #tree-payments-options .list-group .list-group-item.active, #tree-payments-options-collapsed .list-group .list-group-item.active {\n    background-color: rgba(218, 213, 213, 0.95);\n    color: black; }\n\n#tree-payments-options .payments-option, #tree-payments-options-collapsed .payments-option {\n  cursor: pointer; }\n\n#tree-payments-options-collapsed {\n  display: none;\n  z-index: 999999999;\n  width: 16em; }\n  #tree-payments-options-collapsed.display {\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/navigation/options/payments/payment-option.component.scss
// module id = ../../../../../src/app/components/navigation/options/payments/payment-option.component.scss
// module chunks = main